// extracted by mini-css-extract-plugin
module.exports = {"particles":"index-module--particles--3puNa","upperHero":"index-module--upper-hero--AXT5a","lowerHero":"index-module--lower-hero--lnWqv","text":"index-module--text--3y3qZ"};